import React from "react"
import styled from "styled-components"
import {FormattedMessage} from "@irati/utils/lang"

const StyledTag = styled.div`
  padding: 6px;
`

const getUsersSearchText = (tag: string | FormattedMessage) => ({innerRef, innerProps}: {innerRef: any, innerProps: any}) => {
  return (
    <StyledTag ref={innerRef} {...innerProps}>
      {tag}
    </StyledTag>
  )
}

export default getUsersSearchText
